import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { SagService } from 'src/app/api/services';

@Component({
  selector: 'bom-sag-redirect',
  templateUrl: './sag-redirect.component.html',
  styleUrls: ['./sag-redirect.component.scss'],
})

/**
 * Uses a sagId to fetch projektId and then navigate to the correct /projekter/projektId/sag/sagId route
 * If a dokId is given, navigates to the /projekter/projektId/sag/sagId/dokumentation/dokId route
 */
export class SagRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sagService: SagService
  ) {}

  ngOnInit() {
    this.route.params.pipe(take(1)).subscribe(params => {
      const dokId = params.dokId;
      this.sagService.getProjektIdForSag(params.sagId).subscribe({
        next: projektId => {
          if (dokId) {
            this.router.navigate(
              ['projekter', projektId, 'sag', params.sagId, 'dokumentation', dokId],
              {
                replaceUrl: true,
              }
            );
          } else {
            this.router.navigate(['projekter', projektId, 'overblik'], { replaceUrl: true });
          }
        },
      });
    });
  }
}
